import React from 'react';
import Text from '../text';
import Button from '../button';
// eslint-disable-next-line yola/import/no-named-as-default
import Modal from '../modal';
import Render from '../render';
import Icon from '../icon';
import ButtonGroup from '../button-group';
function AlertDialog({
  width = 376,
  height = 220,
  content = undefined,
  offsetX = 0,
  offsetY = 0,
  captions: { title, description, dismiss, submit, descriptionLink },
  descriptionLinkHref = undefined,
  glyph = undefined,
  imgSrc = undefined,
  minHeight = 220,
  onDismiss = undefined,
  handleCancel = undefined,
  onSubmit = undefined,
  onDialogMainAction = undefined,
  onDialogCancel = undefined,
}) {
  const onDismissAction = () => {
    if (onDialogCancel) onDialogCancel();

    if (onDismiss) onDismiss();
  };

  const onCancelAction = () => {
    if (onDialogCancel) onDialogCancel();

    if (handleCancel) {
      handleCancel();
    } else if (onDismiss) {
      onDismiss();
    }
  };

  const onSubmitAction = () => {
    if (onDialogMainAction) onDialogMainAction();

    if (onSubmit) onSubmit();
  };

  const isContentPresented = Boolean(content);

  return (
    <Modal
      overlay="visible"
      centered
      resizable={false}
      draggable={false}
      className="ws-alert-dialog"
      width={width}
      height={height}
      minWidth={312}
      minHeight={minHeight}
      offsetX={offsetX}
      offsetY={offsetY}
      handleCancel={onCancelAction}
    >
      {glyph && !imgSrc && <Icon glyph={glyph} size={24} className="ws-alert-dialog__icon" />}
      {imgSrc && !glyph && <img src={imgSrc} className="ws-alert-dialog__img" alt="" />}
      <Text type="heading-5" className="ws-alert-dialog__title">
        {title}
      </Text>
      <div className="ws-alert-dialog__content">
        {!isContentPresented && (
          <React.Fragment>
            <Text theme="grey">{description} </Text>
            {Boolean(descriptionLink) && Boolean(descriptionLinkHref) && (
              <Text theme="grey">
                {/* eslint-disable-next-line yola/react/jsx-no-target-blank */}
                <a href={descriptionLinkHref} className="ws-alert-dialog__link" target="_blank">
                  {descriptionLink}
                </a>
              </Text>
            )}
          </React.Fragment>
        )}
        {isContentPresented && content}
      </div>
      <ButtonGroup className="ws-submit-dialog__buttons">
        <Render if={Boolean(onSubmit) && Boolean(submit)}>
          <Button stretch="block" size="large" onClick={onSubmitAction}>
            <span>{submit}</span>
          </Button>
        </Render>
        <Render if={Boolean(onDismiss) && Boolean(dismiss)}>
          <Button stretch="block" size="large" onClick={onDismissAction}>
            {dismiss}
          </Button>
        </Render>
      </ButtonGroup>
    </Modal>
  );
}

export default AlertDialog;
